const BASE_URL = "https://jb.dlad.io/"

export {BASE_URL}